import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import ReactPaginate from "react-paginate"
import DeleteButton from "./DeleteButtonList"
import { useDispatch } from "react-redux"
import config from "config"

const TableHeader = ({ header, showActions }) => {
  return (
    <thead>
      <tr>
        {showActions ? (
          <th style={{ cursor: "default" }} key="Action" className="text">
            Action
          </th>
        ) : (
          <th></th>
        )}
        {header?.map(({ header, accessorKey, formatAmount }) => (
          <th
            key={accessorKey}
            className="text"
            style={{
              textAlign: formatAmount ? "right" : "left",
            }}
          >
            {header}
          </th>
        ))}
      </tr>
    </thead>
  )
}

const TableRow = ({
  rowData,
  header,
  backUrl,
  canShow,
  canEdit,
  canDestroy,
  api,
  screen,
  fetchData = () => {},
}) => {
  const lastId = localStorage.getItem("lastId_9cm")
  const previousPath = localStorage.getItem("previousPath_9cm_" + api)

  return (
    <tr key={rowData.id}>
      <td
        style={{
          backgroundColor:
            previousPath == `${backUrl}/${screen}/${lastId}/edit` &&
            rowData.id == lastId
              ? "#b0f2b6"
              : "none",
        }}
      >
        <ul className="list-unstyled hstack gap-1 mb-0">
          {canShow && (
            <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
              <Link
                className="btn btn-sm btn-soft-primary"
                to={`${backUrl}/${screen}/${rowData.id}`}
                onClick={e => {
                  screen == "collaterals"
                    ? (window.location.href = `${backUrl}/${screen}/${rowData.id}`)
                    : null
                }}
              >
                <i className="mdi mdi-eye-outline"></i>
              </Link>
            </li>
          )}
          {canEdit && (
            <li title="Editer">
              <Link
                className="btn btn-sm btn-soft-info"
                to={`${backUrl}/${screen}/${rowData.id}/edit`}
                state={{ active: "details" }}
              >
                <i className="mdi mdi-pencil-outline"></i>
              </Link>
            </li>
          )}
          {canDestroy && (
            <li title="Supprimer">
              <DeleteButton
                url={`https://www.fluxod.com/${api}/${screen}/${rowData.id}`}
                fetchData={fetchData}
              />
            </li>
          )}
        </ul>
      </td>
      {header?.map(({ accessorKey, formatAmount }, index) => (
        <td
          className={formatAmount ? "text-end" : ""}
          style={{
            padding: "12px",
            fontFamily: "Sans-Serif",
            backgroundColor:
              previousPath == `${backUrl}/${screen}/${lastId}/edit` &&
              rowData.id == lastId
                ? "#b0f2b6"
                : "none",
          }}
        >
          {typeof rowData[accessorKey] === "number" &&
          accessorKey != "ref_nav_cash_stock" ? (
            rowData[accessorKey]
              .toLocaleString("fr-FR", {
                style: "currency",
                currency: "EUR",
              })
              .replace("€", "")
          ) : typeof rowData[accessorKey] === "number" &&
            accessorKey == "ref_nav_cash_stock" ? (
            (Math.round(rowData[accessorKey] * 1000000) / 1000000)
              .toLocaleString("fr-FR", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 6,
                maximumFractionDigits: 6,
              })
              .replace("€", "")
          ) : rowData[accessorKey] === "Alive" ? (
            <span
              className="bg-success badge bg-secondary"
              style={{ fontSize: "100%" }}
            >
              {rowData[accessorKey]}
            </span>
          ) : rowData[accessorKey] === "Terminated" ? (
            <span
              className="badge-soft-danger badge bg-secondary"
              style={{ fontSize: "100%" }}
            >
              {rowData[accessorKey]}
            </span>
          ) : (
            rowData[accessorKey] || "——"
          )}
        </td>
      ))}
    </tr>
  )
}

const TableBody = ({
  data,
  header,
  backUrl,
  canShow,
  canEdit,
  canDestroy,
  api,
  screen,
  fetchData = () => {},
}) => {
  return (
    <tbody>
      {data?.map((rowData, rowIndex) => (
        <TableRow
          key={rowIndex}
          rowData={rowData}
          header={header}
          backUrl={backUrl}
          canShow={canShow}
          canEdit={canEdit}
          canDestroy={canDestroy}
          api={api}
          screen={screen}
          fetchData={fetchData}
        />
      ))}
    </tbody>
  )
}

const CustomTable = ({
  data,
  backUrl,
  api,
  screen,
  id,
  id_2,
  fetchData = () => {},
  num,
  setPage = () => {},
}) => {
  const dispatch = useDispatch()

  const [currentPage, setCurrentPage] = useState(num || 0)
  const itemsPerPage = 10
  const pageCount = Math.ceil(data?.data?.length / itemsPerPage)

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected)
    dispatch(setPage(selected))
  }

  const currentData = data.data?.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  )

  const showActions = data?.can_edit || data?.can_show || data?.can_destroy
  useEffect(() => {
    if (pageCount === 1) {
      setCurrentPage(0)
      dispatch(setPage(0))
    } else {
      setCurrentPage(num)
      dispatch(setPage(num))
    }
  }, [pageCount])

  return (
    <div className="table-responsive">
      {data?.can_add ? (
        <div>
          <Link
            to={`${backUrl}/${screen}/new?product_id=${id}&asset_account_id=${id_2}`}
            className="btn btn-sm btn-info"
            style={{ backgroundColor: "#1C529D" }}
          >
            <i className="bx bx-plus"></i>Add
          </Link>
        </div>
      ) : null}

      <>
        <table className="table">
          <TableHeader header={data?.header} showActions={showActions} />
          {data?.data?.length === 0 ? (
            <tr>
              <td colSpan={data?.header?.length + 1}>
                <div
                  style={{
                    fontSize: 12,
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  {" "}
                  <i
                    className="mdi mdi-alert-circle-outline"
                    style={{ fontSize: 36 }}
                  ></i>{" "}
                  No records
                </div>
              </td>
            </tr>
          ) : (
            <TableBody
              screen={screen}
              data={currentData}
              header={data.header}
              backUrl={backUrl}
              canShow={data.can_show}
              canEdit={data.can_edit}
              canDestroy={data.can_destroy}
              api={api}
              fetchData={fetchData}
            />
          )}{" "}
        </table>
        {pageCount <= 1 ? null : (
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination justify-content-center"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            activeClassName={"active"}
            forcePage={currentPage}
          />
        )}
      </>
    </div>
  )
}

export default CustomTable
